import { useContext } from 'react';
import { DashboardContext } from '../dashboard-provider';

export function useDashboardContext() {
  const ctx = useContext(DashboardContext);

  if (!ctx) {
    throw new Error('Unknown dashboard widget context');
  }

  return ctx;
}
